import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
//if component <h1>{this.props.t('lang')}</h1>

function Pic14({ t }) {

    return (
        <div className="mainLayout">
            <div className="mainLayOutInner">
                <br />

                <div className="imageWraper">
                <img src="/images/14.jpg" className="pic1M" alt="pic1" />

                <div className="pic1MDisc">
                    <div>Lyndon Polan Octo.png, Huile sur toile, 40x60, 2019</div>
                </div>
                <span className="arrow1"> <Link to="/13">{"<"}</Link> </span>
                </div>

                





            </div>
        </div>
    );
}


export default withTranslation()(Pic14);